var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23787 0.436561C9.0871 0.366198 8.9129 0.366198 8.76213 0.436561L0.324628 4.37406C0.121403 4.4689 -0.00606942 4.67539 0.000222743 4.89957C0.00651487 5.12375 0.145369 5.32277 0.353594 5.40606L8.79109 8.78106C8.9252 8.8347 9.0748 8.8347 9.20891 8.78106L15.75 6.16462V12.7588C15.1287 12.7588 14.625 13.2625 14.625 13.8838V16.1338H18V13.8838C18 13.2625 17.4963 12.7588 16.875 12.7588V5.71462L17.6464 5.40606C17.8546 5.32277 17.9935 5.12375 17.9998 4.89957C18.0061 4.67539 17.8786 4.4689 17.6754 4.37406L9.23787 0.436561ZM9 7.65296L1.97777 4.84407L9 1.56702L16.0222 4.84407L9 7.65296Z",
    fill: "#5C5E69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69751 8.2946C4.55117 8.23973 4.38861 8.24821 4.24878 8.31801C4.10894 8.38781 4.00446 8.51264 3.96036 8.66257L3.39786 10.5751C3.316 10.8534 3.45923 11.1483 3.72859 11.2561L8.79109 13.2811C8.9252 13.3347 9.0748 13.3347 9.20891 13.2811L14.2714 11.2561C14.5408 11.1483 14.684 10.8534 14.6021 10.5751L14.0396 8.66257C13.9955 8.51264 13.8911 8.38781 13.7512 8.31801C13.6114 8.24821 13.4488 8.23973 13.3025 8.2946L9 9.90803L4.69751 8.2946ZM4.62154 10.4016L4.86894 9.56039L8.80249 11.0355C8.92984 11.0832 9.07017 11.0832 9.19751 11.0355L13.1311 9.56039L13.3785 10.4016L9 12.153L4.62154 10.4016Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationIcon);
export default __webpack_public_path__ + "static/media/graduation-icon.6118083b8b4e570a6c3da7edcefc2c40.svg";
export { ForwardRef as ReactComponent };